import React, {Fragment} from 'react';
import {Activities} from 'components';
import {useNamedSelector} from 'helpers';
import css from './subtasks-checklist.module.scss';

export function SubTasksChecklist({ activity, editable, contextDate, type, detailed }) {
  const hasCheckbox = editable && (type == 'activity' || contextDate);
  const subtasks = useNamedSelector('calendar.subtasksChecklist', { id: activity.id, date: contextDate });
  return (
    <Fragment>
      <ul className={hasCheckbox ? css.checkList : css.bulletList}>
        { subtasks.map(subtask =>
          <li key={subtask.id}>
            { hasCheckbox &&
              <Activities.Checkbox
                activity={subtask}
                className={css.checkbox}
                status={subtask.status}
                subtask={subtask}
                type={type}
              />
            }
            <span>{ subtask.name }</span>
            <span className={css('time', 'pull-right')}>{ subtask.time }</span>
          </li>
        ) }
      </ul>
      { detailed && hasCheckbox && subtasks.length > 1 && !activity.numericalTarget &&
        <p className={css.progress}>
          { subtasks.filter(({ status }) => status == 'Completed').length }/{ subtasks.length } subtasks
        </p>
      }
    </Fragment>
  );
}
